/* GABINS — affichage des pointures selon le marché (affichage seulement : les variantes restent en EU) */
(function () {
  var US = {36:'W5.5',37:'W6',38:'W7',39:'6.5',40:'7',41:'8',42:'8.5',43:'9.5',44:'10',45:'11',46:'12'};
  var UK = {36:'4',37:'4.5',38:'5',39:'6',40:'6',41:'7',42:'7.5',43:'8.5',44:'9',45:'10',46:'11'};
  var c = (window.Shopify && Shopify.country) || '';
  var sys = (c === 'US' || c === 'CA') ? 'US' : ((c === 'GB' || c === 'AU' || c === 'NZ' || c === 'IE') ? 'UK' : 'EU');
  var map = sys === 'US' ? US : (sys === 'UK' ? UK : null);
  var EU_RE = /^(3[6-9]|4[0-6])$/;
  function selectLabel(eu) { return map && map[eu] ? sys + ' ' + map[eu] + ' · EU ' + eu : 'EU ' + eu; }
  function apply() {
    var sels = document.querySelectorAll('[class*="moonbundle"] select, select[class*="moonbundle"]');
    for (var i = 0; i < sels.length; i++) {
      var o = sels[i].options;
      for (var j = 0; j < o.length; j++) {
        var t = (o[j].text || '').trim();
        if (EU_RE.test(t) && o[j].getAttribute('value') !== null) o[j].text = selectLabel(t);
      }
    }
    if (!map) return;
    var pills = document.querySelectorAll('.moonbundle-dynamic-popup-variant-card-label');
    for (var k = 0; k < pills.length; k++) {
      var n = pills[k].firstChild;
      if (n && n.nodeType === 3 && EU_RE.test(n.data.trim()) && map[n.data.trim()]) {
        var eu = n.data.trim();
        pills[k].setAttribute('data-gb-eu', 'EU ' + eu);
        n.data = map[eu];
      }
    }
  }
  if (map) {
    var st = document.createElement('style');
    st.textContent =
      '.moonbundle-dynamic-popup-variant-card-label[data-gb-eu]{font-size:15px;font-weight:600;line-height:1.1;text-align:center}' +
      '.moonbundle-dynamic-popup-variant-card-label[data-gb-eu]::after{content:attr(data-gb-eu);display:block;margin-top:3px;font-size:10px;font-weight:400;opacity:.55;letter-spacing:.02em}' +
      '.moonbundle-dynamic-popup-product-picked-title::after{content:"' + sys + ' sizes \\00b7  EU size underneath";display:block;margin-top:4px;font-size:11px;opacity:.6}';
    document.head.appendChild(st);
  }
  var pending = false;
  function schedule() { if (pending) return; pending = true; setTimeout(function () { pending = false; apply(); }, 30); }
  function start() {
    apply();
    setTimeout(apply, 600); setTimeout(apply, 2000);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
